import React from "react";
import {
  applyDefaultHighSensitivityIfUnset,
  shouldApplyAutopatrolHighSensitivityDefault,
} from "./autopatrolDefaultHighSensitivity";

export const handleProductMasterSwitchEvent = (
  setLocalProductsData: any,
  setProductsData: any,
  event: any,
  productObject: any
) => {
  let objectIndex = 0;
  setLocalProductsData((previousState: any) => {
    const updatedLocalProductsData = [...previousState];
    objectIndex = updatedLocalProductsData.findIndex(
      (product: any) =>
        product.label_name === productObject.label_name &&
        product.name === productObject.name
    );
    // update the local products data by using a for in loop to iterate through the metrics object
    for (const key in updatedLocalProductsData[objectIndex].metrics) {
      const metric = updatedLocalProductsData[objectIndex].metrics[key];
      metric.active = event.target.checked;
      if (event.target.checked && shouldApplyAutopatrolHighSensitivityDefault()) {
        applyDefaultHighSensitivityIfUnset(metric);
      }
    }
    updatedLocalProductsData[objectIndex].open = true;
    return updatedLocalProductsData;
  });
  setProductsData((previousState: any) => {
    const updatedProductsData = [...previousState];
    objectIndex = updatedProductsData.findIndex(
      (product: any) =>
        product.label_name === productObject.label_name &&
        product.name === productObject.name
    );
    for (const key in updatedProductsData[objectIndex].metrics) {
      const metric = updatedProductsData[objectIndex].metrics[key];
      metric.active = event.target.checked;
      if (event.target.checked && shouldApplyAutopatrolHighSensitivityDefault()) {
        applyDefaultHighSensitivityIfUnset(metric);
      }
    }
    updatedProductsData[objectIndex].open = true;
    return updatedProductsData;
  });
};
